// extracted by mini-css-extract-plugin
export default {"wrap":"css_wrap__nAr68","table":"css_table__haBj4","title":"css_title__+e54M","footer":"css_footer__l3kmt","popupconfirm":"css_popupconfirm__INJXx"};